import { useEffect } from 'react';

import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { getContainerHeight, makeResizableElement } from '../Messages/utils';

const StyledLayout = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hasSelectedItem',
})(({ hasSelectedItem }) =>
  hasSelectedItem
    ? { height: '100%' }
    : {
        '& > div': {
          width: '100%',
        },
      },
);

const StyledResizer = styled('div')(() => ({
  borderLeft: '0.3rem solid #eee',
  margin: '0 0.5rem',
  cursor: 'ew-resize',
  '&:hover': {
    borderLeft: '0.5rem solid #21addc',
  },
  '&:active': {
    borderLeft: '0.5rem solid #21addc',
  },
}));

const SplitterComponent = (props) => {
  const {
    isMobileScreen,
    hasSelectedItem,
    MainComponent,
    mainComponentProps,
    DependentComponent,
    dependentComponentProps,
  } = props;

  useEffect(() => {
    makeResizableElement(
      '#messagesResizedList',
      '#messagesResizedContainer',
      '.messages-resizer',
    );
  }, []);

  const height = getContainerHeight();

  const desktopLayout = (
    <Box display="flex" pt="1rem" style={{ height }}>
      <div id="messagesResizedList" style={{ width: '40%', minWidth: '31rem' }}>
        <MainComponent {...mainComponentProps} />
      </div>
      <StyledResizer
        className="messages-resizer left-right"
        style={{ zIndex: 1 }}
      />
      <Box id="messagesResizedContainer" ml="0.5rem" style={{ width: '60%' }}>
        <DependentComponent {...dependentComponentProps} />
      </Box>
    </Box>
  );
  const mobileLayout = (
    <StyledLayout display="flex" pt="1rem" hasSelectedItem={hasSelectedItem}>
      {hasSelectedItem ? (
        <DependentComponent {...dependentComponentProps} />
      ) : (
        <MainComponent {...mainComponentProps} />
      )}
    </StyledLayout>
  );
  return (
    <Box height="100%">{isMobileScreen ? mobileLayout : desktopLayout}</Box>
  );
};

SplitterComponent.defaultProps = {
  hasSelectedItem: false,
  mainComponentProps: {},
  dependentComponentProps: {},
};

SplitterComponent.propTypes = {
  isMobileScreen: PropTypes.bool.isRequired,
  hasSelectedItem: PropTypes.bool,
  MainComponent: PropTypes.instanceOf(Object).isRequired,
  mainComponentProps: PropTypes.instanceOf(Object),
  DependentComponent: PropTypes.instanceOf(Object).isRequired,
  dependentComponentProps: PropTypes.instanceOf(Object),
};

export default SplitterComponent;
